import React, { useLayoutEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils"; // if using Tailwind classnames helper
import { BROKER_LOGO, CURRENT_BROKER_ID, isBrokerBranch } from "@/config/logos";
import { useRecoilState } from "recoil";
import {
  brokerSelectModalAtom,
  technicalSupportModalAtom,
} from "@/Atoms/modal/DialogueAtoms";

const brokers = [
  {
    id: "4",
    name: "Alpaca",
    note: "Virtual Trading",
    logo: "/images/logos/alpaca/alpaca_light.png",
  },

  {
    id: "1",
    name: "Match Trade ",
    note: "Prop Trading",
    logo: BROKER_LOGO["MATCHTRADE"].DARK.textLogo,
  },
  {
    id: "2",
    name: "C-Trader",
    note: <p>{"Live Trading"}</p>,
    logo: BROKER_LOGO["CTRADER"].DARK.icon,
  },
  {
    id: "13",
    name: "Lightspeed",
    note: <p>{"Live Trading"}</p>,
    logo: BROKER_LOGO["LIGHTSPEED"].DARK.icon,
  },
  {
    id: "20",
    name: "Trade Zero",
    disabled: true,
    note: (
      <p>
        {"Virtual Trading"} <br />
        <p>(Coming soon)</p>
      </p>
    ),
    logo: BROKER_LOGO["TRADEZERO"].DARK.icon,
  },
  {
    id: "5",
    name: "MT5",
    disabled: true,
    note: <p>{"Live Trading (Contact us)"}</p>,
    logo: BROKER_LOGO["MT5"].DARK.icon,
  },
];

const BrokerSelectionModal = () => {
  const [selectedBroker, setSelectedBroker] = useState<string>("4");
  const [showConnectForm, setShowConnectForm] = useRecoilState(
    brokerSelectModalAtom
  );
  const [showTechnicalRequest, setShowTechnicalRequest] = useRecoilState(
    technicalSupportModalAtom
  );

  const handleSelect = (id: string) => {
    if (id === "other") return; // don't allow selecting "other"
    setSelectedBroker(id);
  };

  useLayoutEffect(() => {
    if (isBrokerBranch) {
      setShowConnectForm({ isOpen: false });
      showConnectForm?.callback?.(CURRENT_BROKER_ID);
    }
  }, []);
  if (isBrokerBranch) return <></>;

  return (
    <Dialog
      open={true}
      onOpenChange={() => {
        setShowConnectForm({ isOpen: false, callback: () => {} });
      }}
    >
      <form>
        <DialogContent className="max-w-3xl sm:h-auto h-[100dvh]  flex flex-col justify-center">
          <DialogHeader>
            <DialogTitle className="text-[--marketplace-blue] text-xl">
              Choose your broker
            </DialogTitle>
            <DialogDescription>
              Select your broker below to connect your Nextrades account to the
              API and start trading.
            </DialogDescription>
          </DialogHeader>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 py-6">
            {brokers.map((broker) => {
              const isDisabled = broker.disabled;
              const isSelected = selectedBroker === broker.id;

              return (
                <div
                  key={broker.id}
                  onClick={() => {
                    if (!isDisabled) handleSelect(broker.id);
                    else {
                      setShowTechnicalRequest({
                        isOpen: true,
                      });
                    }
                  }}
                  className={cn(
                    "cursor-pointer rounded-lg border p-6 text-center transition-all flex flex-col items-center justify-center",
                    isSelected
                      ? "border-blue-500 bg-blue-500/10"
                      : "border-gray-600 hover:border-muted-foreground",
                    isDisabled && "opacity-50  hover:border-gray-600"
                  )}
                >
                  {broker.logo && (
                    <>
                      <img
                        src={broker.logo}
                        alt={broker.name}
                        className="mx-auto h-8 mb-2"
                      />
                      <p className="text-sm text-muted-foreground">
                        {broker.note}
                      </p>
                    </>
                  )}
                </div>
              );
            })}
          </div>

          <DialogFooter className="flex   !justify-between flex-row">
            <div className=" text-muted-foreground text-sm">
              <p>
                {"Don’t see your broker listed?"} <br />
                <span
                  onClick={() => {
                    setShowTechnicalRequest({
                      isOpen: true,
                    });
                  }}
                  className="text-sm text-blue-400 cursor-pointer "
                >
                  {"Contact us"}
                </span>
                {" and we'll you get connected."}
              </p>
            </div>
            <Button
              className="bg-[--marketplace-blue]"
              type="submit"
              onClick={() => {
                setShowConnectForm({ isOpen: false });
                showConnectForm?.callback?.(selectedBroker);
              }}
              disabled={!selectedBroker}
            >
              Next
            </Button>
          </DialogFooter>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default BrokerSelectionModal;
